import React, { useEffect, useState } from "react";
import {
    FiMapPin,
    FiCalendar,
    FiUser,
    FiMinus,
    FiPlus,
    FiSearch,
  } from "react-icons/fi";


const InputBoxSubHeader = ({ inputbox, setInputBox, cities }) => {

    cities.sort((a, b) => b.a2z_score - a.a2z_score);
    const LandMarkSuggestions = cities.slice(0,5)  
  let countries = cities;
  // const [input, setInputBox] = useState("");
  const [suggestion, setSuggestions] = useState([]);
  const [select, setSelect] = useState("");
  const [clicked, setClicked] = useState(false);

  const handleChange = (e) => {
    let value = e.target.value;
    let matches = [];

    if (value.length >= 1) {
      const regex = new RegExp(`${value}`, "gi");
      matches = countries.filter((item) => regex.test(item.name));
    }
    setSuggestions(matches);
    setSelect(value);
  };

  const selectValue = (item) => {
    setSelect(item.name);
    setSuggestions("");
    setInputBox(item.id);
  };

  const clearSearch = () => {
    setInputBox("");
    setSuggestions("");
    setSelect("");
  };

  useEffect(()=>{
    if(select===""){
        setInputBox("")
    }
  },[select])
  return (
    <div className="font-hk w-1/4 mx-3 flex flex-row">
      <input
        className="border-[1px] w-full shadow-md py-2 px-4 rounded-md leading-tight focus:outline-none focus:shadow-outline "
        type="text"
        placeholder="Search Villas"
        value={select}
        onChange={handleChange}
        style={{ textTransform: "capitalize" }}
        onClick={() => {
          setClicked(!clicked);
        }}
      />
        <div
          className="ml-4 bg-black cursor-pointer text-white flex justify-center items-center w-10 rounded-lg transition-all hover:scale-[1.05]"
          onClick={() => {
            selectValue(select)
            setClicked(!clicked)
          }}
        >
          <FiSearch />
        </div>
      {suggestion?.length > 0 ? (
        <div className="flex flex-row mt-10 absolute px-2">
          <div className="bg-white cursor-pointer rounded-lg w-full shadow-md ">
            {suggestion.slice(0, 8).map((item) => {
              return (
                <div
                  className=" suggestions text-center px-2 my-2 py-2 text-[14px] border-b-[1px]  font-medium"
                  key={item.id}
                  onClick={() => {
                    selectValue(item);
                    setClicked(false);
                  }}
                >
                  {item.name}
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        clicked && (
          <div className="flex flex-row mt-10 absolute px-2">
            <div className="bg-white cursor-pointer rounded-lg  w-ful shadow-md">
              {LandMarkSuggestions.map((item) => {
                return (
                  <div
                    className=" suggestions text-center px-2 my-2 py-2 text-[14px] border-b-[1px] font-medium "
                    key={item.id}
                    onClick={() => {
                      selectValue(item);
                      setClicked(false);
                    }}
                  >
                    {item.name}
                  </div>
                );
              })}
            </div>
          </div>
        )
      )}
      {/* {suggestion?.length > 0 ? (
        <div className="bg-white cursor-pointer rounded-lg">
          {suggestion.map((item) => {
            return (
              <div
                className="text-center p-1 text-[14px] border-b-[1px] font-semibold"
                key={item.id}
                onClick={() => selectValue(item.name)}
              >
                {item.name}
              </div>
            );
          })}
        </div>
      ) : null} */}
    </div>
  );
};

export default InputBoxSubHeader;
